export default {
  FETCHED_ALL: 'FETCHED_ALL_MARKET_STATES',
  FETCHED_MULTIPLE: 'FETCHED_MARKET_STATES',
  FETCHED_SINGLE: 'FETCHED_MARKET_STATE',
};
